export default __webpack_public_path__ + "8df3c1d1022d22abd337908c70cec000.png";